import React from "react";

import { useSelector } from "react-redux";
import { Bar } from "react-chartjs-2";

import ChartDataLabels from "chartjs-plugin-datalabels";
import Chart from "chart.js/auto";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Draggable from "react-draggable";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Paper } from "@mui/material";
Chart.register(ChartDataLabels);
Chart.defaults.set("plugins.datalabels", {
  color: "#000",
  formatter: function (value) {
    return value.toLocaleString();
  },
});

const labels = [
  "Office Computer",
  "Furniture and Fittings",
  "Office Equipment",
  "Plant and Machinery",
  "Motor Vehicle",
  "Land",
  "Office Building",
  "Intangibles",
  "Right-of-use asset",
];
function PaperComponent(props) {
  return (
    <Draggable
      handle='#draggable-dialog-title'
      cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}
export default function BarChart() {
  const [open, setOpen] = React.useState(false);
  const [labelName, setLabelName] = React.useState("");
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setLabelName("");
  };
  const tangibleAsset = useSelector((state) => state.assets);
  const intangibleAsset = useSelector((state) => state.intangible);
  const rightOfUse = useSelector((state) => state.rightOfUse);
  const activeRightOfUse = rightOfUse.filter(
    (data) => moment(data.exhaustion_date) >= moment()
  );
  const dataToShow = [...tangibleAsset];

  const [dataShow, setData] = React.useState([]);
  React.useEffect(() => {
    if (labelName !== "") {
      handleModal();
    }
  }, [labelName]);
  // Example usage:
  function handleModal() {
    const res = dataToShow.filter((asset) => {
      const claimValues = Object.values(asset);

      return claimValues.some(
        (value) =>
          value && value.toString().toLowerCase() === labelName.toLowerCase()
      );
    });

    setData(res);
    handleClickOpen();
  }
  const columns = Object.keys(dataShow[0] || {})
    .filter((key) => key !== "id")
    .map((key) => ({
      field: key,
      headerName: key,
      minWidth: 170,
      align: "left",
    }));
  let office_computer = [];
  let land = [];
  let motor_vehicle = [];
  let office_building = [];
  let furniture_fittings = [];
  let office_equipment = [];
  let plant_and_machinery = [];

  tangibleAsset.map((data) => {
    return createData(data.code, data.category);
  });
  intangibleAsset.map((data) => {
    return createData(data.code, data.category);
  });
  function createData(code, category) {
    if (category === "office computer") {
      office_computer.push(code);
    }
    if (category === "land") {
      land.push(code);
    }
    if (category === "motor vehicle") {
      motor_vehicle.push(code);
    }
    if (category === "office building") {
      office_building.push(code);
    }
    if (category === "furniture and fittings") {
      furniture_fittings.push(code);
    }
    if (category === "plant and machinery") {
      plant_and_machinery.push(code);
    }
    if (category === "office equipment") {
      office_equipment.push(code);
    }
    return {
      code,
      category,
    };
  }

  const data = {
    labels,
    datasets: [
      {
        fill: true,
        label: "Number of assets",
        data: [
          office_computer.length,
          furniture_fittings.length,
          office_equipment.length,
          plant_and_machinery.length,
          motor_vehicle.length,
          land.length,
          office_building.length,
          intangibleAsset.length,
          activeRightOfUse.length,
        ],
        borderColor: "#000000",
        backgroundColor: "#3D4F58",
        height: "100px",
        cursor: "pointer",
        datalabels: {
          display: true,
          backgroundColor: "transparent",
          anchor: "end",
          align: "end",
          font: {
            size: 14,
          },
        },
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: true,
        anchor: "end",
        align: "top",
        color: "#000",
        fontSize: { font: "12px" },
        font: {
          weight: "bold",
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: true,

        text: "Number of assets per Pool",
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedElementIndex = elements[0].index;
        const labelName = data.labels[clickedElementIndex];
        setLabelName(labelName.toLowerCase());
      }
    },
  };
  return (
    <div>
      <Bar
        style={{ width: 450, height: "200px", cursor: "pointer" }}
        data={data}
        options={options}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby='draggable-dialog-title'>
        <DialogTitle style={{ cursor: "move" }} id='draggable-dialog-title'>
          {labelName} Assets
        </DialogTitle>
        <DialogContent>
          <Paper>
            <DataGrid
              columns={columns}
              getRowId={(row) => row.id}
              rows={dataShow}
              slots={{ toolbar: GridToolbar }}
              style={{ height: "50vh" }}
              disableRowSelectionOnClick
            />
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
